export class ParamtereReq {
    id: number;
    paramId: number;
    buyer: string;
    parameter: string;
    createdUser: string;
    createdAt: string;
    constructor(
        id: number,
        paramId: number,
        buyer: string,
        createdAt: string, parameter: string, createdUser: string,) {
        this.id = id;
        this.paramId = paramId;
        this.buyer = buyer;
        this.parameter = parameter
        this.createdAt = createdAt;
        this.createdUser = createdUser;
    }
}
